import { useEffect, useState } from "react";

import Card from "@mui/material/Card";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Pagination from "@mui/material/Pagination";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";

import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useNavigate } from "react-router-dom";

import { getAllRevendeursApi, deleteRevendeurApi } from "api/superAdmin";

function RevendeursList() {
  const navigate = useNavigate();

  const [tableData, setTableData] = useState({
    revendeurs: [],
    total: 0,
    pages: 1,
    page: 1,
  });

  const [nameSearch, setNameSearch] = useState("");
  const [emailSearch, setEmailSearch] = useState("");
  const [phoneSearch, setPhoneSearch] = useState("");
  const [pseudoSearch, setPseudoSearch] = useState("");

  const [loading, setLoading] = useState(false);

  const [limitPerPage, setLimitPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const getTableData = async (
    name = "",
    email = "",
    phone = "",
    pseudo = "",
    page = 1,
    limit = 10
  ) => {
    console.log("getTableData (Revendeurs) called with:", {
      name: name,
      email: email,
      phone: phone,
      pseudo: pseudo,
      page: page,
      limit: limit,
    });

    setLoading(true);
    try {
      const response = await getAllRevendeursApi(name, email, phone, pseudo, page, limit);

      console.log("Revendeur Data:", response);

      setTableData({
        revendeurs: response.revendeurs,
        total: response.totalRevendeurs,
        pages: response.totalPages,
        page: response.page,
      });
    } catch (err) {
      console.error("Error fetching revendeurs:", err);
      toast.error(
        err.response?.data?.error ||
          "Une erreur s'est produite lors de la récupération de la liste des revendeurs."
      );
      setTableData({ revendeurs: [], total: 0, pages: 1, page: 1 });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTableData(nameSearch, emailSearch, phoneSearch, pseudoSearch, currentPage, limitPerPage);
  }, [currentPage, limitPerPage]);

  const handleEdite = (revendeurData) => {
    navigate(`/revendeurs/modifier/${revendeurData._id}`);
  };

  const handleDeleteItem = async (revendeurId) => {
    const result = await Swal.fire({
      title: "Êtes-vous sûr?",
      text: "Vous ne pourrez pas revenir en arrière!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimez-le!",
      cancelButtonText: "Annuler",
    });

    if (result.isConfirmed) {
      try {
        await deleteRevendeurApi(revendeurId);

        Swal.fire({
          title: "Supprimé!",
          text: "Le revendeur a été supprimé avec succès.",
          icon: "success",
        });

        const newCurrentPage =
          tableData.revendeurs.length === 1 && currentPage > 1 ? currentPage - 1 : currentPage;

        getTableData(
          nameSearch,
          emailSearch,
          phoneSearch,
          pseudoSearch,
          newCurrentPage,
          limitPerPage
        );

        if (newCurrentPage !== currentPage) {
          setCurrentPage(newCurrentPage);
        }
      } catch (error) {
        console.error("Error deleting revendeur:", error.response?.data?.error || error.message);
        toast.error(
          error.response?.data?.error ||
            "Une erreur s'est produite lors de la suppression du revendeur."
        );
      }
    }
  };

  const handleRefreshData = () => {
    getTableData(nameSearch, emailSearch, phoneSearch, pseudoSearch, currentPage, limitPerPage);
  };

  const handleNameSearchChange = (event) => {
    setNameSearch(event.target.value);
  };

  const handleEmailSearchChange = (event) => {
    setEmailSearch(event.target.value);
  };

  const handlePhoneSearchChange = (event) => {
    setPhoneSearch(event.target.value);
  };

  const handlePseudoSearchChange = (event) => {
    setPseudoSearch(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleApplyFilters = () => {
    setLoading(true);
    setCurrentPage(1);

    getTableData(nameSearch, emailSearch, phoneSearch, pseudoSearch, 1, limitPerPage);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={0} mb={9} p={1}>
        <Grid container spacing={1} alignItems="center" mb={2}>
          <Grid item xs={12} md={2.5}>
            <MDInput
              type="text"
              label="Recherche par nom"
              size="small"
              fullWidth
              value={nameSearch}
              onChange={handleNameSearchChange}
            />
          </Grid>
          <Grid item xs={12} md={2.5}>
            <MDInput
              type="email"
              label="Recherche par email"
              size="small"
              fullWidth
              value={emailSearch}
              onChange={handleEmailSearchChange}
            />
          </Grid>
          <Grid item xs={12} md={2.5}>
            <MDInput
              type="text"
              label="Recherche par téléphone"
              size="small"
              fullWidth
              value={phoneSearch}
              onChange={handlePhoneSearchChange}
            />
          </Grid>
          <Grid item xs={12} md={2.5}>
            <MDInput
              type="text"
              label="Recherche par Pseudo"
              size="small"
              fullWidth
              value={pseudoSearch}
              onChange={handlePseudoSearchChange}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <MDButton
              variant="contained"
              color="info"
              onClick={handleApplyFilters}
              fullWidth
              disabled={loading}
            >
              Filter
            </MDButton>
          </Grid>
        </Grid>
        <Card>
          <TableContainer component={Paper} mt={0}>
            {loading ? (
              <Box display="flex" justifyContent="center" alignItems="center" height="200px">
                <CircularProgress />
              </Box>
            ) : (
              <>
                <Table aria-label="revendeurs table">
                  <TableHead style={{ display: "table-header-group" }}>
                    <TableRow>
                      <TableCell
                        align="left"
                        style={{
                          color: "#7b809a",
                          fontSize: "0.7rem",
                          opacity: "0.7",
                          textTransform: "uppercase",
                        }}
                      >
                        Actions
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          color: "#7b809a",
                          fontSize: "0.7rem",
                          opacity: "0.7",
                          textTransform: "uppercase",
                        }}
                      >
                        Revendeur
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          color: "#7b809a",
                          fontSize: "0.7rem",
                          opacity: "0.7",
                          textTransform: "uppercase",
                        }}
                      >
                        Email
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          color: "#7b809a",
                          fontSize: "0.7rem",
                          opacity: "0.7",
                          textTransform: "uppercase",
                        }}
                      >
                        Téléphone
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          color: "#7b809a",
                          fontSize: "0.7rem",
                          opacity: "0.7",
                          textTransform: "uppercase",
                        }}
                      >
                        Nom d'utilisateur
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          color: "#7b809a",
                          fontSize: "0.7rem",
                          opacity: "0.7",
                          textTransform: "uppercase",
                        }}
                      >
                        Événement associé
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          color: "#7b809a",
                          fontSize: "0.7rem",
                          opacity: "0.7",
                          textTransform: "uppercase",
                        }}
                      >
                        Produit associé
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData.revendeurs.map((revendeur) => (
                      <TableRow
                        key={revendeur._id}
                        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                      >
                        <TableCell
                          align="left"
                          style={{
                            color: "#7b809a",
                            fontSize: "0.8rem",
                            fontWeight: "600",
                            width: "120px",
                          }}
                        >
                          <Stack direction="row" spacing={1}>
                            <IconButton
                              color="info"
                              size="small"
                              onClick={() => handleEdite(revendeur)}
                              sx={{ padding: "4px" }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                              color="error"
                              size="small"
                              onClick={() => handleDeleteItem(revendeur._id)}
                              sx={{ padding: "4px" }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Stack>
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{
                            color: "#7b809a",
                            fontSize: "0.8rem",
                            fontWeight: "600",
                          }}
                        >
                          <MDTypography
                            component="a"
                            href="#"
                            variant="caption"
                            color="text"
                            fontWeight="medium"
                          >
                            {`${revendeur.firstName} ${revendeur.lastName}`}
                          </MDTypography>
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "400" }}
                        >
                          {revendeur.email}
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "400" }}
                        >
                          {revendeur.phone}
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "400" }}
                        >
                          {revendeur.pseudo}
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "400" }}
                        >
                          {revendeur.eventID ? revendeur.eventID.eventTitle : "indéfini"}
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "400" }}
                        >
                          {revendeur.fromProduced
                            ? `${revendeur.fromProduced.firstName} ${revendeur.fromProduced.lastName}`
                            : "indéfini"}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                {tableData.pages > 1 && (
                  <MDBox display="flex" justifyContent="center" mt={2} mb={2}>
                    <Pagination
                      count={tableData.pages}
                      page={tableData.page}
                      onChange={handlePageChange}
                      color="info"
                    />
                  </MDBox>
                )}
              </>
            )}
          </TableContainer>
        </Card>
      </MDBox>
      <Footer />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </DashboardLayout>
  );
}

export default RevendeursList;
